import React, { useState } from 'react';
import MainContainer from '../../../components/MainContainer';
import LoadingSimpleBackdrop from '../../tools/LoadingSimpleBackdrop';
import { headerDataMission } from '../../../data/modules/mission-header';
import SearchIcon from '@mui/icons-material/Search';
import { Grid, makeStyles } from '@material-ui/core';
import { Autocomplete, Button, FormControl, TextField, createFilterOptions } from '@mui/material';
import Spacer from '../../../components/Spacer';
import TimesheetTable from './TimesheetTable';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    elevation: 2,
    borderRadius: "8px",
    marginTop: "2%",
    height: "60%",
    boxShadow: "box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;",
  },
  btn: {
    margin: "1% 0.25% 1% 0.25%",
    fontWeight: 600,
  },
}));
const Timesheet = () => {
  const classes = useStyles();
  const [reference, setReference] = useState([]);
  const [filter, setFilter] = useState({
    title: '',
    state: '',
    reference: '',
    destination: '',
    debut: '',
    fin: ''
  });
  const [appliedFilter, setAppliedFilter] = useState({
    title: '',
    state: '',
    reference: '',
    destination: '',
    debut: '',
    fin: ''
  });
  const STATE_TIMESHEET = [
    { label: 'Nouveau', value: null, color: 'blue' },
    { label: 'Elaboré', value: 'PLANNING', color: 'orange' },
    { label: 'En attente de validation', value: 'PENDING', color: 'purple' },
    { label: 'Validé', value: 'CONFIRMED', color: 'green' },
    { label: 'Refusé', value: 'REFUSED', color: 'red' },
    { label: 'Tous', value: '', color: 'blue' }
  ];

  const handleChangeFilter = (e) => {
    const { name, value } = e.target;
    setFilter(prev => ({ ...prev, [name]: value }));
  };

  const referenceFilterOptions = createFilterOptions({
    matchFrom: 'any',
    stringify: (option) => option ?? ''
  });

  const handleFilter = () => {
    setAppliedFilter({ ...filter });
  };

  const handleResetFilter = () => {
    const empty = {
      title: '',
      state: '',
      reference: '',
      destination: '',
      debut: '',
      fin: ''
    };
    setFilter(empty);
    setAppliedFilter(empty);
  };

    return (
    <MainContainer {...headerDataMission}>
     <Grid container xs={12} spacing={2} >
        <Grid item xs={12} sm={6} md={3}>
          <label>Objet de la mission :</label>
          <FormControl fullWidth variant="outlined" size="small">
          <TextField
            fullWidth
            id="title"
            size="small"
            variant="outlined"
            value={filter.title}
            name="title"
            onChange={handleChangeFilter}
          />
          </FormControl>
        </Grid>
          <Grid item xs={12} sm={6} md={3}>
          <label>Statut timesheet :</label>
          <FormControl fullWidth variant="outlined" size="small">
            <Autocomplete
                      id="tags-outlined"
                      options={STATE_TIMESHEET}
                      value={filter.state ? STATE_TIMESHEET.find(option => option.value == filter.state) : null}
                      onChange={(_, newValue) =>
                        setFilter(prev => ({ ...prev, state: newValue ? newValue.value : '' }))
                      }
                      getOptionLabel={option => option.label}
                      isOptionEqualToValue={(option, value) => option.value === value.value}
                      filterSelectedOptions
                      size="small"
                      sx={{
                        '& .MuiInputBase-root': { height: 40 },
                        '& .MuiInputBase-input': { padding: '4px 8px' }
                      }}
                      renderInput={params => (
                        <TextField {...params} variant="outlined" size="small" />
                      )}
                    />
          </FormControl>
        </Grid>
        <Grid container xs={12} sm={6} md={6} spacing={4} justifyContent={"flex-end"} >
          <div style={{paddingTop: '30px'}}>

            <Button
            variant="outlined"
            color="secondary"
            onClick={handleResetFilter}
            className={classes.btn}
          >
            Réinitialiser
          </Button>
          </div>
          <Spacer x={1} />
          <div style={{paddingTop: '30px'}}>
           
          <Button
            variant="contained"
            color="primary"
            onClick={handleFilter}
            className={classes.btn}
          >
            <SearchIcon style={{ marginRight: '8px' }} />
            Filtrer
          </Button>
         
          </div>
          <Spacer x={1} />
        </Grid>              
        <Grid item xs={12} sm={6} md={3}>
            <label>Référence:</label>
            <FormControl fullWidth variant="outlined" size="small">
            <Autocomplete
                id="tags-outlined"
                freeSolo
                options={reference}
                filterOptions={referenceFilterOptions}
                sx={{
                '& .MuiInputBase-root': { height: 40 }, 
                '& .MuiInputBase-input': { padding: '4px 8px' } 
                }}
                getOptionLabel={(option) =>
                `${option ?? ''}`
                }
                filterSelectedOptions
                onChange={(_, newValue) => {
                  setFilter(prev => ({ ...prev, reference: newValue || '' }));
                }}
                inputValue={filter.reference}
                onInputChange={(_, newInputValue) => {
                  setFilter(prev => ({ ...prev, reference: newInputValue || '' }));
                }}
                size='small'
                value={filter.reference}
                renderInput={(params) => (
                <TextField {...params} variant="outlined" size="small" />
                )}
            />
            </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
            Destination :
            <TextField
            fullWidth
            id="destination"
            size="small"
            variant="outlined"
            value={filter.destination}
            name="destination"
            onChange={handleChangeFilter}
            />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                Date début:
                <TextField
                fullWidth
                id="date_debut"
                size="small"
                variant="outlined"
                type="date"
                value={filter.debut}
                name="debut"
                onChange={handleChangeFilter}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                Date fin:
                <TextField
                fullWidth
                id="date_fin"
                size="small"
                variant="outlined"
                type="date"
                value={filter.fin}
                name="fin"
                onChange={handleChangeFilter}
                />
            </Grid>
      </Grid>

        <TimesheetTable filter={appliedFilter} setReference={setReference} />
        </MainContainer>
    );
};

export default Timesheet;
